/* eslint-disable */
/* eslint-disable no-restricted-globals, no-undef */
import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Grid,
  IconButton,
  Select,
  Text,
  VStack,
  Badge,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Spinner,
  UnorderedList,
  ListItem
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { AddIcon, EditIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import convertDateFormat, {
  deleteUsers,
  getUser,
} from "../../Redux/AdminReducer/action";
import Pagination from "./Pagination";
import AdminNavTop from "../AdminNavTop";
import { useModalToast } from "../../context/GlobalModalToast";

const ROLE_COLORS = {
  admin: "red",
  instructor: "purple",
  employee: "blue",
  teacher: "purple",
  student: "blue",
  user: "gray",
};

const Users = () => {
  const store = useSelector((store) => store.AdminReducer.users);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { toast, confirm, prompt } = useModalToast();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState("");
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const limit = 4;

  const { isOpen: isLnaOpen, onOpen: onLnaOpen, onClose: onLnaClose } = useDisclosure();
  const [lnaLogs, setLnaLogs] = useState([]);
  const [isLoadingLna, setIsLoadingLna] = useState(false);
  const [activeLnaUser, setActiveLnaUser] = useState("");
  const [expandedProgress, setExpandedProgress] = useState({});

  const handleViewLna = async (userId, userName) => {
    setActiveLnaUser(userName);
    onLnaOpen();
    setIsLoadingLna(true);
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/lna-results/${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLnaLogs(res.data);
    } catch (err) {
      toast({ title: "Error", description: "Failed to fetch LNA results.", status: "error" });
    } finally {
      setIsLoadingLna(false);
    }
  };

  const userRole = useSelector(state => state.UserReducer.role);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleSelect = (e) => {
    const { value } = e.target;
    setOrder(value);
  };

  useEffect(() => {
    dispatch(getUser(page, limit, search, order, selectedCompany, selectedRole));
  }, [page, search, order, selectedCompany, selectedRole, dispatch]);

  useEffect(() => {
    if (userRole === "super_admin") {
      const fetchCompanies = async () => {
        try {
          const token = JSON.parse(localStorage.getItem("user"))?.token || "";
          const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/companies`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setCompanies(res.data);
        } catch (err) {
          console.error("Failed to fetch companies", err);
        }
      };
      fetchCompanies();
    }
  }, [userRole]);

  const handleDelete = async (id, name, role) => {
    let keepCourses = false;
    const lowerRole = role ? role.toLowerCase() : '';
    
    if (lowerRole === 'instructor' || lowerRole === 'teacher') {
      const action = await prompt({
        title: `Delete ${name}`,
        description: "Type 'keep' to delete the user but KEEP their courses.\nType 'erase' to completely ERASE the user AND their courses.",
        placeholder: "keep or erase",
        confirmText: "Proceed",
        status: "warning",
      });
      
      if (action && action.trim().toLowerCase() === 'keep') {
        keepCourses = true;
      } else if (action && action.trim().toLowerCase() === 'erase') {
        keepCourses = false;
      } else {
        return; // Abort deletion
      }
    } else {
      const confirmed = await confirm({
        title: "Delete User",
        description: `Are you sure you want to completely erase ${name} and their enrollments?`,
        confirmText: "Delete",
        status: "warning",
      });
      if (!confirmed) return;
    }

    dispatch(deleteUsers(id, keepCourses));
    toast({ title: `${name} Deleted`, description: "User and associated data will be removed.", status: "success", duration: 3000 });
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const count = 2;

  const handlePageButton = (val) => {
    setPage((prev) => prev + val);
  };

  const normalizeRole = (role) => {
    if (role === "teacher") return "instructor";
    if (role === "student") return "employee";
    return role || "employee";
  };

  const bgMain = useColorModeValue("var(--background)", "gray.900");
  const textMain = useColorModeValue("gray.800", "gray.100");
  const textSub = useColorModeValue("gray.500", "gray.400");
  const cardBg = useColorModeValue("white", "gray.800");
  const cardBorder = useColorModeValue("gray.100", "gray.700");
  const tableHeaderBg = useColorModeValue("gray.50", "gray.700");

  return (
    <Box mx="auto" w="100%" bg={bgMain} color={textMain}>
      <Box>
        <AdminNavTop handleSearch={handleSearch} />
        <Box>
          <Grid
            templateColumns={{
              xl: "repeat(3,20% 60% 20%)",
              lg: "repeat(3,20% 60% 20%)",
              base: "repeat(1,1fr)",
            }}
            gap={{ xl: 0, lg: 0, base: 7 }}
            m={3}
          >
            <Text fontWeight={"bold"}>Employee Management</Text>
            <Flex gap={4}>
              {userRole === "super_admin" && (
                <Select w={"80%"} onChange={(e) => setSelectedCompany(e.target.value)} placeholder="All Branches">
                  {companies.map(c => (
                    <option key={c.companyId} value={c.companyId}>{c.companyName}</option>
                  ))}
                </Select>
              )}
              <Select w={"80%"} onChange={(e) => setSelectedRole(e.target.value)} placeholder="All Roles">
                <option value="employee">Employee</option>
                <option value="instructor">Instructor</option>
                <option value="admin">Admin</option>
              </Select>
              <Select w={"80%"} onChange={handleSelect} placeholder="Sort By">
                <option value="asc">Name A → Z</option>
                <option value="desc">Name Z → A</option>
              </Select>
            </Flex>
            <Box fontWeight={"bold"}>
              <Link to="/admin/users/add">+ Add Employee</Link>
            </Box>
          </Grid>
          <Box
            w="100%"
            overflowX="auto"
            borderRadius="md"
            border="1px solid"
            borderColor={useColorModeValue("gray.200", "gray.700")}
            mb={4}
          >
            <Table variant="striped" size="sm" borderRadius="md" w="100%">
              <Thead>
                <Tr>
                  <Th>Employee Name</Th>
                  <Th>Role</Th>
                  <Th>Email</Th>
                  <Th>Branch/Company</Th>
                  <Th>Department</Th>
                  <Th>Nationality</Th>
                  <Th>Course Progress</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              {store?.length > 0 &&
                store?.map((el, i) => {
                  const displayRole = normalizeRole(el.role);
                  return (
                    <Tbody key={i}>
                      <Tr>
                        <Td fontWeight="600">{el.fullName || el.name}</Td>
                        <Td>
                          <Badge
                            colorScheme={ROLE_COLORS[displayRole] || "gray"}
                            borderRadius="full"
                            px={2}
                            py={0.5}
                            textTransform="capitalize"
                          >
                            {displayRole}
                          </Badge>
                        </Td>
                        <Td>{el.email}</Td>
                        <Td fontWeight="bold" color="blue.600">{el.companyName || "Global"}</Td>
                        <Td>{el.department || "N/A"}</Td>
                        <Td>{el.nationality || "Global"}</Td>
                        <Td>
                          {el.progressList && el.progressList.length > 0 ? (
                            <VStack align="start" spacing={1}>
                              {(expandedProgress[el._id]
                                ? el.progressList
                                : el.progressList.slice(0, 3)
                              ).map((prog, idx) => (
                                <Text key={idx} fontSize="xs" fontWeight="bold">
                                  • {prog.courseTitle}:{" "}
                                  <Text
                                    as="span"
                                    color={
                                      prog.progress === 100
                                        ? "green.500"
                                        : "purple.500"
                                    }
                                  >
                                    {prog.progress}%
                                  </Text>
                                </Text>
                              ))}
                              {el.progressList.length > 3 && (
                                <Text
                                  fontSize="xs"
                                  color="blue.500"
                                  cursor="pointer"
                                  fontWeight="semibold"
                                  onClick={() =>
                                    setExpandedProgress((prev) => ({
                                      ...prev,
                                      [el._id]: !prev[el._id],
                                    }))
                                  }
                                >
                                  {expandedProgress[el._id]
                                    ? "Show less"
                                    : `+${el.progressList.length - 3} more`}
                                </Text>
                              )}
                            </VStack>
                          ) : (
                            <Text fontSize="xs" color={textSub}>
                              Not Enrolled
                            </Text>
                          )}
                        </Td>
                        <Td>
                          <Flex direction="column" gap={2} minW="140px">
                            <Button size="xs" w="full" colorScheme="purple" variant="solid" onClick={() => handleViewLna(el._id, el.fullName || el.name)}>
                              LNA Results
                            </Button>
                            <Flex gap={2} w="full">
                              <Link to={`/admin/users/edit/${el._id}`} style={{ flex: 1 }}>
                                <Button size="xs" w="full" colorScheme="blue" variant="outline" leftIcon={<EditIcon />}>
                                  Edit
                                </Button>
                              </Link>
                              <Button
                                size="xs"
                                flex={1}
                                colorScheme="red"
                                variant="outline"
                                onClick={() =>
                                  handleDelete(el._id, el.fullName || el.name, el.role)
                                }
                              >
                                Delete
                              </Button>
                            </Flex>
                          </Flex>
                        </Td>
                      </Tr>
                    </Tbody>
                  );
                })}
            </Table>
          </Box>
          <Box textAlign={{ xl: "right", lg: "right", base: "left" }} display="flex" gap={2} justifyContent={{ xl: "flex-end", lg: "flex-end", base: "flex-start" }} alignItems="center">
            <Button 
              colorScheme="purple" 
              variant="outline" 
              borderRadius="xl"
              isDisabled={page <= 1} 
              onClick={() => handlePageButton(-1)}
            >
              Prev
            </Button>
            <Pagination
              totalCount={count}
              current_page={page}
              handlePageChange={handlePageChange}
            />
            <Button
              colorScheme="purple" 
              variant="outline" 
              borderRadius="xl"
              isDisabled={page >= count}
              onClick={() => handlePageButton(1)}
            >
              Next
            </Button>
        </Box>
      </Box>
      </Box>

      {/* LNA Results Modal */}
      <Modal isOpen={isLnaOpen} onClose={onLnaClose} isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="xl">
          <ModalHeader>LNA Results: {activeLnaUser}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            {isLoadingLna ? (
              <Flex justify="center" p={4}><Spinner color="purple.500" /></Flex>
            ) : lnaLogs.length === 0 ? (
              <Text color="gray.500">This employee has not submitted an LNA survey yet.</Text>
            ) : (
              <Box>
                <Text fontWeight="bold" mb={2} color="purple.600">Selected Struggles & Interests:</Text>
                <UnorderedList spacing={2}>
                  {lnaLogs.map((log, idx) => (
                    <ListItem key={idx} fontWeight="500">{log.topic}</ListItem>
                  ))}
                </UnorderedList>
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

    </Box>
  );
};

export default Users;
